!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("ati-ui-react/components/Button"), require("ati-ui-react/components/Preloader"), require("ati-ui-react/components/CloseButton"), require("ati-ui-react/widgets/GalleryArrow"), require("ati-ui-react/widgets/DownloadButton"), require("ati-ui-react/components/icons/DownloadBold"), require("ati-ui-react/components/icons/Doc"), require("ati-ui-react/components/icons/Alert")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react", "ati-ui-react/components/Button", "ati-ui-react/components/Preloader", "ati-ui-react/components/CloseButton", "ati-ui-react/widgets/GalleryArrow", "ati-ui-react/widgets/DownloadButton", "ati-ui-react/components/icons/DownloadBold", "ati-ui-react/components/icons/Doc", "ati-ui-react/components/icons/Alert"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react"), require("ati-ui-react/components/Button"), require("ati-ui-react/components/Preloader"), require("ati-ui-react/components/CloseButton"), require("ati-ui-react/widgets/GalleryArrow"), require("ati-ui-react/widgets/DownloadButton"), require("ati-ui-react/components/icons/DownloadBold"), require("ati-ui-react/components/icons/Doc"), require("ati-ui-react/components/icons/Alert")) : e["ati-ui-react"] = t(e.React, e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0]);
}(this, function (n, r, i, o, a, c, l, s, u) {
  return p = {}, d.m = f = {
    0: function (e, t) {
      e.exports = n;
    },
    140: function (e, t) {
      e.exports = o;
    },
    2: function (e, t, i) {
      "use strict";

      var n,
        r,
        c = function () {
          return n = void 0 === n ? !(!(window && document && document.all) || window.atob) : n;
        },
        o = (r = {}, function (e) {
          if (void 0 === r[e]) {
            var t = document.querySelector(e);
            if (window.HTMLIFrameElement && t instanceof window.HTMLIFrameElement) try {
              t = t.contentDocument.head;
            } catch (e) {
              t = null;
            }
            r[e] = t;
          }
          return r[e];
        }),
        s = [];
      function u(e) {
        for (var t = -1, n = 0; n < s.length; n++) if (s[n].identifier === e) {
          t = n;
          break;
        }
        return t;
      }
      function l(e, t) {
        for (var n = {}, r = [], i = 0; i < e.length; i++) {
          var o = e[i],
            a = t.base ? o[0] + t.base : o[0],
            c = n[a] || 0,
            l = "".concat(a, " ").concat(c);
          n[a] = c + 1;
          c = u(l), o = {
            css: o[1],
            media: o[2],
            sourceMap: o[3]
          };
          -1 !== c ? (s[c].references++, s[c].updater(o)) : s.push({
            identifier: l,
            updater: function (t, e) {
              var n, r, i;
              {
                var o;
                i = e.singleton ? (o = h++, n = m = m || d(e), r = p.bind(null, n, o, !1), p.bind(null, n, o, !0)) : (n = d(e), r = function (e, t, n) {
                  var r = n.css,
                    i = n.media,
                    n = n.sourceMap;
                  i ? e.setAttribute("media", i) : e.removeAttribute("media");
                  n && "undefined" != typeof btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(n)))), " */"));
                  if (e.styleSheet) e.styleSheet.cssText = r;else {
                    for (; e.firstChild;) e.removeChild(e.firstChild);
                    e.appendChild(document.createTextNode(r));
                  }
                }.bind(null, n, e), function () {
                  !function (e) {
                    if (null === e.parentNode) return;
                    e.parentNode.removeChild(e);
                  }(n);
                });
              }
              return r(t), function (e) {
                e ? e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap || r(t = e) : i();
              };
            }(o, t),
            references: 1
          }), r.push(l);
        }
        return r;
      }
      function d(e) {
        var t,
          n = document.createElement("style"),
          r = e.attributes || {};
        if (void 0 !== r.nonce || (t = i.nc) && (r.nonce = t), Object.keys(r).forEach(function (e) {
          n.setAttribute(e, r[e]);
        }), "function" == typeof e.insert) e.insert(n);else {
          e = o(e.insert || "head");
          if (!e) throw Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          e.appendChild(n);
        }
        return n;
      }
      var a,
        f = (a = [], function (e, t) {
          return a[e] = t, a.filter(Boolean).join("\n");
        });
      function p(e, t, n, r) {
        n = n ? "" : r.media ? "@media ".concat(r.media, " {").concat(r.css, "}") : r.css;
        e.styleSheet ? e.styleSheet.cssText = f(t, n) : (r = document.createTextNode(n), (n = e.childNodes)[t] && e.removeChild(n[t]), n.length ? e.insertBefore(r, n[t]) : e.appendChild(r));
      }
      var m = null,
        h = 0;
      e.exports = function (e, o) {
        (o = o || {}).singleton || "boolean" == typeof o.singleton || (o.singleton = c());
        var a = l(e = e || [], o);
        return function (e) {
          if ("[object Array]" === Object.prototype.toString.call(e = e || [])) {
            for (var t = 0; t < a.length; t++) {
              var n = u(a[t]);
              s[n].references--;
            }
            for (var e = l(e, o), r = 0; r < a.length; r++) {
              var i = u(a[r]);
              0 === s[i].references && (s[i].updater(), s.splice(i, 1));
            }
            a = e;
          }
        };
      };
    },
    25: function (e, t) {
      e.exports = r;
    },
    312: function (e, t) {
      e.exports = a;
    },
    313: function (e, t, n) {
      (t = e.exports = n(4)()).push([e.i, ".iblnP-2-0-721{font-family:Verdana,Dejavu Sans,Geneva,Tahoma,sans-serif}.iblnP-2-0-721 ._3TurO-2-0-721{display:inline-block}.iblnP-2-0-721 ._14yNr-2-0-721{position:fixed;top:0;left:0;width:100%;height:100%;z-index:9999999;background:rgba(6,21,35,.8);display:flex;align-items:center;justify-content:center}.iblnP-2-0-721 ._14yNr-2-0-721 ._1_nas-2-0-721{margin:0;position:fixed;top:30px;left:30px;color:#fff;padding:12px 16px;font-size:20px;line-height:24px}@media(max-width:767px){.iblnP-2-0-721 ._14yNr-2-0-721 ._1_nas-2-0-721{top:0;left:0}}.iblnP-2-0-721 ._14yNr-2-0-721 .IN6zU-2-0-721{display:flex;align-items:center;justify-content:center;width:100%;height:inherit;max-height:100%;padding:20px 124px;text-align:center;vertical-align:middle}@media(max-width:767px){.iblnP-2-0-721 ._14yNr-2-0-721 .IN6zU-2-0-721{padding:0}}.iblnP-2-0-721 ._14yNr-2-0-721 ._2LJck-2-0-721{position:absolute}.iblnP-2-0-721 ._14yNr-2-0-721 ._2QhPM-2-0-721{position:fixed;right:0;top:0;width:84px;height:84px}@media(max-width:767px){.iblnP-2-0-721 ._14yNr-2-0-721 ._2QhPM-2-0-721{width:48px;height:48px}}.iblnP-2-0-721 ._14yNr-2-0-721 ._1T9PT-2-0-721{position:fixed;bottom:0;right:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}@media(max-width:767px){.iblnP-2-0-721 ._14yNr-2-0-721 .R4344-2-0-721{padding:20px 16px}}.iblnP-2-0-721 ._14yNr-2-0-721 ._1Zp3e-2-0-721{position:fixed;top:134px;bottom:134px;display:flex;align-items:center;outline:0}@media(max-width:768px){.iblnP-2-0-721 ._14yNr-2-0-721 ._1Zp3e-2-0-721{max-width:67px}}.iblnP-2-0-721 ._14yNr-2-0-721 ._1Zp3e-2-0-721._3CTNd-2-0-721{left:0}.iblnP-2-0-721 ._14yNr-2-0-721 ._1Zp3e-2-0-721._2P_VQ-2-0-721{right:0}@media(max-height:360px){.iblnP-2-0-721 ._14yNr-2-0-721 ._1Zp3e-2-0-721{top:60px;bottom:60px}}.iblnP-2-0-721 ._14yNr-2-0-721 ._2annP-2-0-721{box-sizing:border-box}@media(max-width:767px){.iblnP-2-0-721 ._14yNr-2-0-721 ._2annP-2-0-721{padding-left:35px}}.iblnP-2-0-721 ._14yNr-2-0-721 ._31R5t-2-0-721{box-sizing:border-box}@media(max-width:767px){.iblnP-2-0-721 ._14yNr-2-0-721 ._31R5t-2-0-721{padding-right:35px}}.iblnP-2-0-721 ._14yNr-2-0-721 .IWy9T-2-0-721{max-width:100%;max-height:100%}.iblnP-2-0-721 ._14yNr-2-0-721 ._3OQCc-2-0-721{display:flex;flex-direction:column}.iblnP-2-0-721 ._14yNr-2-0-721 ._1cYJp-2-0-721,.iblnP-2-0-721 ._14yNr-2-0-721 ._3Ruzp-2-0-721{font-size:11px;color:#fff;opacity:.6}.iblnP-2-0-721 ._14yNr-2-0-721 ._1NZXc-2-0-721{padding-top:20px}.iblnP-2-0-721 ._14yNr-2-0-721 ._2ZLMO-2-0-721{display:inline-block;text-align:center;color:#fff;padding:15px}.iblnP-2-0-721 ._14yNr-2-0-721 ._2ZLMO-2-0-721:first-letter,.iblnP-2-0-721 ._14yNr-2-0-721 .jeOhJ-2-0-721{text-transform:uppercase}.iblnP-2-0-721 ._14yNr-2-0-721 ._2e0pD-2-0-721{position:fixed;left:0;bottom:0;font-size:17px;color:#fff;font-weight:700;padding:20px 30px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}@media(max-width:767px){.iblnP-2-0-721 ._14yNr-2-0-721 ._2e0pD-2-0-721{padding:20px 16px}}", ""]), t.locals = {
        container: "iblnP-2-0-721",
        trigger: "_3TurO-2-0-721",
        overlay: "_14yNr-2-0-721",
        title: "_1_nas-2-0-721",
        content: "IN6zU-2-0-721",
        loading: "_2LJck-2-0-721",
        close: "_2QhPM-2-0-721",
        "download-button": "_1T9PT-2-0-721",
        "download-button-small": "R4344-2-0-721",
        control: "_1Zp3e-2-0-721",
        prev: "_3CTNd-2-0-721",
        next: "_2P_VQ-2-0-721",
        "control-right": "_2annP-2-0-721",
        "control-left": "_31R5t-2-0-721",
        "preview-image": "IWy9T-2-0-721",
        "preview-failed-info": "_3OQCc-2-0-721",
        "preview-failed-description": "_3Ruzp-2-0-721",
        "file-size": "_1cYJp-2-0-721",
        "no-preview-icon": "_1NZXc-2-0-721",
        "no-preview-text": "_2ZLMO-2-0-721",
        "file-format": "jeOhJ-2-0-721",
        fraction: "_2e0pD-2-0-721"
      };
    },
    399: function (e, t) {
      e.exports = c;
    },
    4: function (e, t) {
      e.exports = function () {
        var a = [];
        return a.toString = function () {
          for (var e = [], t = 0; t < this.length; t++) {
            var n = this[t];
            n[2] ? e.push("@media " + n[2] + "{" + n[1] + "}") : e.push(n[1]);
          }
          return e.join("");
        }, a.i = function (e, t) {
          "string" == typeof e && (e = [[null, e, ""]]);
          for (var n = {}, r = 0; r < this.length; r++) {
            var i = this[r][0];
            "number" == typeof i && (n[i] = !0);
          }
          for (r = 0; r < e.length; r++) {
            var o = e[r];
            "number" == typeof o[0] && n[o[0]] || (t && !o[2] ? o[2] = t : t && (o[2] = "(" + o[2] + ") and (" + t + ")"), a.push(o));
          }
        }, a;
      };
    },
    400: function (e, t) {
      e.exports = l;
    },
    401: function (e, t) {
      e.exports = s;
    },
    402: function (e, t) {
      e.exports = u;
    },
    5: function (e, t, n) {
      var r;
      !function () {
        "use strict";

        var o = {}.hasOwnProperty;
        function a() {
          for (var e = [], t = 0; t < arguments.length; t++) {
            var n = arguments[t];
            if (n) {
              var r = typeof n;
              if ("string" == r || "number" == r) e.push(this && this[n] || n);else if (Array.isArray(n)) e.push(a.apply(this, n));else if ("object" == r) if (n.toString === Object.prototype.toString) for (var i in n) o.call(n, i) && n[i] && e.push(this && this[i] || i);else e.push(n.toString());
            }
          }
          return e.join(" ");
        }
        e.exports ? (a.default = a, e.exports = a) : void 0 === (r = function () {
          return a;
        }.apply(t, [])) || (e.exports = r);
      }();
    },
    51: function (e, t) {
      e.exports = i;
    },
    540: function (e, t, n) {
      "use strict";

      n.r(t), n.d(t, "default", function () {
        return k;
      });
      var r = n(0),
        h = n.n(r),
        g = function () {
          var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "",
            t = (1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "").match(/^.*\.(.+)$/),
            e = e.match(/^.*\/(.+)$/);
          return e ? e[1] : t ? t[1] : void 0;
        },
        i = n(140),
        b = n.n(i),
        o = n(312),
        y = n.n(o),
        a = n(399),
        v = n.n(a),
        t = n(51),
        w = n.n(t),
        i = n(5),
        o = n.n(i),
        a = n(2),
        t = n.n(a),
        i = n(313),
        a = n.n(i),
        i = {
          insert: "head",
          singleton: !1
        },
        a = (t()(a.a, i), a.a.locals || {}),
        x = o.a.bind(a),
        a = function (e) {
          var t = e.src,
            n = e.handleImageLoad,
            r = e.handleImageLoadFailed,
            e = t.fileName,
            t = t.link;
          return h.a.createElement("img", {
            alt: e,
            className: x("preview-image"),
            src: t,
            onLoad: n,
            onError: r
          });
        },
        _ = Object(r.memo)(a),
        a = n(25),
        c = n.n(a),
        a = n(400),
        l = n.n(a),
        a = n(401),
        s = n.n(a),
        a = n(402),
        u = n.n(a),
        a = function (e) {
          var t = e.fileNotFound,
            n = e.src,
            r = e.strings,
            i = n.fileName,
            o = n.link,
            e = n.mimeType,
            n = n.size || "",
            i = i || r.fileName,
            i = g(e, i);
          return h.a.createElement("div", {
            className: x("preview-failed-info")
          }, h.a.createElement("div", {
            className: x("no-preview-icon")
          }, t ? h.a.createElement(u.a, {
            width: "24",
            height: "21",
            color: "rgba(207, 206, 206, 1)"
          }) : h.a.createElement(s.a, {
            width: "60",
            height: "60",
            color: "rgba(207, 206, 206, 1)"
          })), h.a.createElement("div", {
            className: x("no-preview-text")
          }, t && r.fileNotFound, i && !t && h.a.createElement("div", null, r.fileFormat, h.a.createElement("span", {
            className: x("file-format")
          }, " ".concat(i))), !t && h.a.createElement("div", {
            className: x("preview-failed-description")
          }, r.previewIsNotAvailable)), !t && h.a.createElement(h.a.Fragment, null, h.a.createElement(c.a, {
            size: "small",
            href: o,
            before: h.a.createElement(l.a, {
              width: "10",
              height: "12"
            })
          }, r.download), h.a.createElement("div", {
            className: x("file-size")
          }, n)));
        },
        N = Object(r.memo)(a);
      function d(t, e) {
        var n,
          r = Object.keys(t);
        return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n)), r;
      }
      function f(r) {
        for (var e = 1; e < arguments.length; e++) {
          var i = null != arguments[e] ? arguments[e] : {};
          e % 2 ? d(Object(i), !0).forEach(function (e) {
            var t, n;
            t = r, e = i[n = e], n in t ? Object.defineProperty(t, n, {
              value: e,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : t[n] = e;
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(i)) : d(Object(i)).forEach(function (e) {
            Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(i, e));
          });
        }
        return r;
      }
      var a = {
          downloadFile: "Скачать файл",
          download: "Скачать",
          fileName: "Название файла отсутствует",
          imageLoadFailed: "Невозможно загрузить картинку",
          previewIsNotAvailable: "просмотр недоступен",
          fileNotFound: "файл не найден",
          fileFormat: "Файл в формате"
        },
        p = {
          ru: a,
          en: f(f({}, a), {
            downloadFile: "Download file",
            download: "Download",
            fileName: "No file name",
            imageLoadFailed: "Unable to load image",
            previewIsNotAvailable: "preview is not available",
            fileNotFound: "file not found",
            fileFormat: "File format"
          })
        };
      function m(e) {
        return (m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function P(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      function O(e, t) {
        return (O = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      function j(n) {
        var r = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var e,
            t = E(n);
          return e = r ? (e = E(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments), t = this, !(e = e) || "object" !== m(e) && "function" != typeof e ? function (e) {
            if (void 0 !== e) return e;
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }(t) : e;
        };
      }
      function E(e) {
        return (E = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      var L = /gif|jpe?g|png|svg|webp|bmp/i,
        a = function () {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), t && O(e, t);
          }(o, r["Component"]);
          var e,
            t,
            n,
            i = j(o);
          function o(e) {
            var r;
            return function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, o), (r = i.call(this, e)).triggerPaginate = function (e, t) {
              var e = !t && e.currentTarget && e.currentTarget.dataset.arrowdirection,
                n = t || e;
              r.setState(function () {
                return {
                  imageLoading: !0,
                  src: {}
                };
              }, function () {
                return r.switchPage(n);
              });
            }, r.switchPage = function (e) {
              var t = (0, r.props.paginate)(e, r.state.current),
                n = t.src,
                e = n.mimeType,
                n = n.fileName,
                n = g(e, n);
              r.setState({
                current: t.current,
                src: t.src,
                imageLoading: L.test(n),
                imageLoadFailed: !1
              });
            }, r.handleArrowPress = function (e) {
              "ArrowLeft" === e.key && r.triggerPaginate(e, "prev"), "ArrowRight" === e.key && r.triggerPaginate(e, "next");
            }, r.handleClose = function (e) {
              var t = e.target,
                t = "click" === e.type && (t === r.modal || t === r.content),
                e = "keyup" === e.type && 27 === e.which;
              (t || e) && r.closeModal();
            }, r.handleImageLoadFailed = function () {
              r.setState({
                imageLoadFailed: !0,
                imageLoading: !1
              });
            }, r.handleImageLoad = function () {
              r.setState({
                imageLoading: !1
              });
            }, r.openModal = function () {
              r.setState({
                active: !0,
                paginate: r.props.paginate,
                src: r.props.src,
                imageLoadFailed: !1
              }), document.addEventListener("click", r.handleClose), document.addEventListener("keyup", r.handleClose), document.addEventListener("keyup", r.handleArrowPress), document.body.style.overflow = "hidden";
            }, r.closeModal = function () {
              document.removeEventListener("click", r.handleClose), document.removeEventListener("keyup", r.handleClose), document.removeEventListener("keyup", r.handleArrowPress), document.body.style.overflow = "", r.setState({
                active: !1,
                current: r.state.initialData.current
              });
            }, r.setModalRef = function (e) {
              r.modal = e;
            }, r.setContentRef = function (e) {
              r.content = e;
            }, r.state = {
              active: !1,
              src: e.src,
              current: e.current,
              initialData: {
                current: e.current
              },
              imageLoading: !1,
              imageLoadFailed: !1
            }, r.strings = p[e.locale] || p.ru, r;
          }
          return e = o, (t = [{
            key: "render",
            value: function () {
              var e = this.state,
                t = e.current,
                n = e.imageLoadFailed,
                r = e.src,
                i = e.imageLoading,
                o = r.fileName,
                a = r.link,
                c = r.mimeType,
                l = this.props,
                s = l.className,
                u = l.buttonClassName,
                d = l.button,
                f = l.buttonStyles,
                p = l.fraction,
                m = l.showCurrentPosition,
                e = 1 !== p,
                l = o || this.strings.fileName,
                o = n || 0 === Object.keys(r).length || !a,
                n = g(c, l),
                n = !o && (c && /image\/(?!tif)/.test(c) || !c && L.test(n));
              return h.a.createElement("div", {
                className: x("container", s)
              }, h.a.createElement("span", {
                className: x("trigger", u),
                onClick: this.openModal,
                role: "button",
                tabIndex: "0",
                style: f
              }, d), this.state.active && h.a.createElement("div", {
                className: x("overlay"),
                ref: this.setModalRef
              }, h.a.createElement("h2", {
                className: x("title")
              }, l), h.a.createElement("div", {
                className: x("content", {
                  loading: i
                }),
                ref: this.setContentRef
              }, n && h.a.createElement(_, {
                src: r,
                handleImageLoad: this.handleImageLoad,
                handleImageLoadFailed: this.handleImageLoadFailed
              }), !i && !n && h.a.createElement(N, {
                fileNotFound: o,
                strings: this.strings,
                src: r
              }), i && !n && h.a.createElement(w.a, {
                small: !0
              })), e && h.a.createElement("div", {
                className: x("control", "prev")
              }, h.a.createElement(y.a, {
                arrow: "left",
                "data-arrowdirection": "prev",
                onClick: this.triggerPaginate,
                role: "button",
                tabIndex: "0",
                withBackground: !0,
                className: x("control-left")
              })), e && h.a.createElement("div", {
                className: x("control", "next")
              }, h.a.createElement(y.a, {
                arrow: "right",
                "data-arrowdirection": "next",
                onClick: this.triggerPaginate,
                role: "button",
                tabIndex: "0",
                withBackground: !0,
                className: x("control-right")
              })), m && h.a.createElement("div", {
                className: x("fraction")
              }, "".concat(t + 1, " из ").concat(p)), n && !i && h.a.createElement("div", {
                className: x("download-button")
              }, h.a.createElement(v.a, {
                value: this.strings.download,
                href: a,
                className: x("download-button-small"),
                withBackground: !0
              })), h.a.createElement("div", {
                className: x("close")
              }, h.a.createElement(b.a, {
                close: this.closeModal,
                withBackground: !0
              }))));
            }
          }]) && P(e.prototype, t), n && P(e, n), o;
        }();
      a.defaultProps = {
        src: {},
        showCurrentPosition: !0
      };
      var k = a;
    }
  }, d.c = p, d.d = function (e, t, n) {
    d.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, d.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, d.t = function (t, e) {
    if (1 & e && (t = d(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var n = Object.create(null);
    if (d.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var r in t) d.d(n, r, function (e) {
      return t[e];
    }.bind(null, r));
    return n;
  }, d.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return d.d(t, "a", t), t;
  }, d.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, d.p = "", d(d.s = 540);
  function d(e) {
    if (p[e]) return p[e].exports;
    var t = p[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return f[e].call(t.exports, t, t.exports, d), t.l = !0, t.exports;
  }
  var f, p;
});